import React, { useCallback } from 'react';
import { logisticLayers, mapUpperLayers } from 'constants/mapTypes';
import { useAppDispatch, useAppSelector } from 'hooks';
import { settingsActions } from 'store/slices/mapV2/mapReducer/settingsSlice';
import { typesSelector } from 'store/slices/mapV2/mapReducer/settingsSlice/selectors';

import { DropdownSection } from 'components/DropdownSection';

import MapTypeElement from './MapTypeElement';

import './style.scss';

const MapTypes = () => {
  const dispatch = useAppDispatch();
  const mapTypes = useAppSelector(typesSelector);

  const handleSetMapTypes = useCallback(
    (name: string) => () => {
      const currentType = mapTypes[name];

      const setMapTypeActive = (
        name: string,
        active: boolean,
        backing?: true
      ) => {
        const backingTypes = Object.fromEntries(
          Object.entries(mapTypes)
            .filter(([key, item]) => item.type === 'style')
            .map(([key, item]) => [key, { ...item, active: false }])
        );
        const mapTypesToSet = backing
          ? { ...mapTypes, ...backingTypes }
          : mapTypes;

        dispatch(
          settingsActions.setTypes({
            ...mapTypesToSet,
            [name]: {
              ...currentType,
              active,
            },
          })
        );
      };

      if (currentType.type === 'style') {
        if (currentType.active) return;
        setMapTypeActive(name, true, true);
        return;
      }

      setMapTypeActive(name, !currentType.active);
    },
    [mapTypes]
  );

  return (
    <div className="flex flex-col gap-4 p-4 overflow-auto">
      <DropdownSection
        title="Спутниковые слои"
        classNames={{ container: 'gap-4', content: 'flex flex-col gap-3' }}
      >
        {mapUpperLayers.imagery.map((item, index) => (
          <MapTypeElement
            key={index}
            title={item.label}
            description={item.description}
            name={item.name}
            active={mapTypes[item.name].active}
            onSwitch={handleSetMapTypes(item.name)}
            preview={item.preview}
            opacitySlider
          />
        ))}
      </DropdownSection>
      <DropdownSection
        title="Высоты"
        classNames={{ container: 'gap-4', content: 'flex flex-col gap-3' }}
      >
        {mapUpperLayers.height.map((item, index) => (
          <MapTypeElement
            key={index}
            title={item.label}
            description={item.description}
            name={item.name}
            active={mapTypes[item.name].active}
            onSwitch={handleSetMapTypes(item.name)}
            icon={item.icon}
            preview={item.preview}
            opacitySlider
          />
        ))}
      </DropdownSection>
      <DropdownSection
        title="Открытые данные об инфраструктуре"
        classNames={{ container: 'gap-4', content: 'flex flex-col gap-3' }}
      >
        {logisticLayers.map((item, index) => (
          <MapTypeElement
            key={index}
            title={item.title}
            description={item.description}
            icon={item.icon}
            name={item.name}
            active={mapTypes[item.name].active}
            onSwitch={handleSetMapTypes(item.name)}
          />
        ))}
      </DropdownSection>
    </div>
  );
};

export default MapTypes;
